import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

const baseText = 'How to apply for a'

const applyTitles: Record<CreditCardProductCategory, string> = {
    [CreditCardProductCategory.BalanceTransfer]: `${baseText} balance transfer credit card`,
    [CreditCardProductCategory.BestCards]: `${baseText} credit card`,
    [CreditCardProductCategory.Cashback]: `${baseText} cashback credit card`,
    [CreditCardProductCategory.Combined]: `${baseText} balance transfer and purchase credit card`,
    [CreditCardProductCategory.PoorCredit]: `${baseText} credit card for bad credit`,
    [CreditCardProductCategory.Purchase]: `${baseText} 0% purchase credit card`,
    [CreditCardProductCategory.Rewards]: `${baseText} rewards credit card`,
    [CreditCardProductCategory.Travel]: `${baseText} travel credit card`,
}

export default applyTitles
